import { css } from 'styled-components';
import type { Variant } from '@makemydeal/dr-ui-bricks-types';

// Define styles for different typography variants (e.g., h1, h2, body1, etc.)
export const VARIANT_STYLES = {
    h1: css`
        font-size: 6rem;
        font-weight: 300;
        line-height: 1.167;
    `,
    h2: css`
        font-size: 3.75rem;
        font-weight: 300;
        line-height: 1.2;
    `,
    h3: css`
        font-size: 3rem;
        font-weight: 400;
        line-height: 1.167;
    `,
    h4: css`
        font-size: 2.125rem;
        font-weight: 400;
        line-height: 1.235;
    `,
    h5: css`
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 1.334;
    `,
    h6: css`
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 1.6;
    `,
    subtitle1: css`
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.75;
    `,
    subtitle2: css`
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.57;
    `,
    body1: css`
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
    `,
    body2: css`
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.43;
    `,
    caption: css`
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.66;
    `,
    button: css`
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.75;
        text-transform: uppercase;
    `,
    overline: css`
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 2.66;
        text-transform: uppercase;
    `
};

export const VARIANT_MAP: Record<Variant, keyof JSX.IntrinsicElements> = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    caption: 'span',
    button: 'span',
    overline: 'span'
};
